import useId from '../utils/useId';
import * as React from 'react';
export const codexSvg = React.forwardRef(function codexSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_codex__a_${id_0})`,
      d: 'M12.085 4.46a6.1 6.1 0 0 1 3.047-.417q2 .23 3.564 1.7a.1.1 0 0 0 .05.028.1.1 0 0 0 .056 0 6.07 6.07 0 0 1 4.062.367l.063.03.154.075A6.1 6.1 0 0 1 26 9.442q.416 1.02.42 2.126c.02.55-.04 1.099-.18 1.63a.16.16 0 0 0 .04.154 6 6 0 0 1 1.578 2.893q.578 2.85-1.183 5.14l-.18.22a6.06 6.06 0 0 1-2.936 1.851.16.16 0 0 0-.107.101c-.255.735-.511 1.364-.987 1.992-1.2 1.583-2.963 2.462-4.948 2.45q-2.373-.011-4.21-1.735a.14.14 0 0 0-.14-.032c-.517.167-1.04.19-1.605.184a5.9 5.9 0 0 1-2.593-.621 6.06 6.06 0 0 1-2.147-1.78c-.203-.27-.404-.523-.552-.823a8 8 0 0 1-.493-1.281 6.1 6.1 0 0 1-.019-3.064.2.2 0 0 0 .008-.075.1.1 0 0 0-.036-.064 5.96 5.96 0 0 1-1.379-2.201 5.2 5.2 0 0 1-.334-1.59 7 7 0 0 1 .188-2.133q.676-2.223 2.577-3.49.425-.282.801-.44.43-.178.862-.303a.13.13 0 0 0 .086-.088A6 6 0 0 1 9.636 6.31a6.05 6.05 0 0 1 2.45-1.85m4.643 14.086a.849.849 0 0 0 0 1.695h4.848a.85.85 0 0 0 .34-1.645.85.85 0 0 0-.34-.05zm-5.446-6.24a.85.85 0 0 0-1.474.842l1.696 2.965-1.688 2.848a.849.849 0 0 0 1.46.866l1.938-3.274a.85.85 0 0 0 .007-.853z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_codex__a_${id_0}`,
          x1: 16,
          x2: 16,
          y1: 4,
          y2: 28,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#b1a7ff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.5,
          stopColor: '#7a9dff',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#3941ff',
        }),
      ),
    ),
  );
});
codexSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var codex = {
  category: 'brand',
  colorable: false,
  name: 'codex',
  svg: codexSvg,
};
